import React from 'react';
import { Appointment } from '../../types';
import AppointmentList from './AppointmentList';
import QuickActions from './QuickActions';

interface QuickPanelProps {
  appointments: Appointment[];
  loading?: boolean;
  onViewCalendar: () => void;
  onRaportCaz: () => void;
  onAddNote: () => void;
  onSchedule: () => void;
}

/** First widget of the right rail: Programări + Acțiuni rapide in one card. */
const QuickPanel: React.FC<QuickPanelProps> = ({
  appointments,
  loading,
  onViewCalendar,
  onRaportCaz,
  onAddNote,
  onSchedule,
}) => (
  <aside className="w-full rounded-xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
    <AppointmentList
      appointments={appointments}
      loading={loading}
      onViewCalendar={onViewCalendar}
      embedded
    />
    <div className="my-5 border-t border-slate-200" />
    <QuickActions
      onRaportCaz={onRaportCaz}
      onAddNote={onAddNote}
      onSchedule={onSchedule}
    />
  </aside>
);

export default QuickPanel;
